import { createApiClient } from "Network/ApiClient";

export const PolicyAxiosInstance = createApiClient("policy/");
